var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00025 7.00018C3.05106 7.86 4.97749 10.0002 8.00025 10.0002C11.0232 10 12.9495 7.88532 14.0002 7.02557C14.4787 7.02562 14.7874 7.50071 14.5452 7.91327C13.7052 9.3436 11.6538 12 8.00025 12.0002C4.34699 12.0002 2.29456 9.34476 1.45435 7.91425C1.14819 7.39297 1.39592 7.01575 2.00025 7.00018Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91431 9L1.50009 10.4142",
    stroke: "#8F8F8F",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9L14.4142 10.4142",
    stroke: "#8F8F8F",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11L10.5176 12.9319",
    stroke: "#8F8F8F",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11L5 12.7321",
    stroke: "#8F8F8F",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.d0fbfa75814ff8bab25f9bcd4b208de3.svg";
export { ForwardRef as ReactComponent };